import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import Select from 'react-select';

import useUpbMatchPartners from 'components/upb_match_explorer/hooks/useUpbMatchPartners';
import { fmtPct } from 'components/upb_match_explorer/format';

function DpSearchSelect({ onSelect, influencedOnly }) {
  const { data, loading } = useUpbMatchPartners({ influencedOnly });

  const options = useMemo(
    () =>
      (data?.data || []).map(partner => ({
        value: partner.entity_id,
        label: partner.name,
        matchPct: partner.match_pct,
      })),
    [data],
  );

  return (
    <Select
      classNamePrefix="themed_select"
      isLoading={loading}
      options={options}
      value={null}
      placeholder="Search distributor partners…"
      onChange={option => option && onSelect(option.value)}
      formatOptionLabel={option => (
        <span style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
          <span>{option.label}</span>
          <span style={{ opacity: 0.6 }}>{fmtPct(option.matchPct)}</span>
        </span>
      )}
    />
  );
}

DpSearchSelect.propTypes = {
  onSelect: PropTypes.func.isRequired,
  influencedOnly: PropTypes.bool,
};

DpSearchSelect.defaultProps = {
  influencedOnly: false,
};

export default DpSearchSelect;
